export default function returnProfileBackgroundImage(backgroundImage, username) {
    if(backgroundImage === '') {
        return { url: '/profile/defaultBackground.png', alt: "Waco Exchange default profile background image" }
    } else {
        return { url: backgroundImage, alt: `${username}'s profile background picture on Waco Exchange` }
    }
}